<div class="on-off-box">
  <div class="on-off-box-title" [ngClass]="{ 'on-off-box-title-disabled': !editable }" *ngIf="isOn">
    {{ 'common.on' | labelsProvider }}
  </div>
  <div class="on-off-box-title" [ngClass]="{ 'on-off-box-title-disabled': !editable }" *ngIf="!isOn">
    {{ 'common.off' | labelsProvider }}
  </div>
  <app-status-toggle
    [inputStatus]="isOn"
    [editable]="editable"
    (toggleOnClick)="toggleChanged($event)"
    [changeValueFromOutside$]="changeValueFromOutside$"
  >
  </app-status-toggle>
</div>
